import { render, staticRenderFns } from "./NameOnCard.vue?vue&type=template&id=679d4adb&scoped=true&"
import script from "./NameOnCard.vue?vue&type=script&lang=js&"
export * from "./NameOnCard.vue?vue&type=script&lang=js&"
import style0 from "./NameOnCard.vue?vue&type=style&index=0&id=679d4adb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679d4adb",
  null
  
)

export default component.exports